(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
var T13 = {
        brakD:  __pewniaki_inline_cfg[0],
        przed:  __pewniaki_inline_cfg[1],
        przedy: __pewniaki_inline_cfg[2],
        naj:    __pewniaki_inline_cfg[3],
        med:    __pewniaki_inline_cfg[4],
        najOp:  __pewniaki_inline_cfg[5],
        brakO:  __pewniaki_inline_cfg[6],
        medOp:  __pewniaki_inline_cfg[7]
    };

(function () {
    var krokDomyslny = __pewniaki_inline_cfg[8];
    function krokZ(dane) {
        var mod = dane && dane.model;
        return (mod && mod.rozproszenie_krok != null) ? mod.rozproszenie_krok : krokDomyslny;
    }
    function tys(v) { return String(v).replace(/\B(?=(\d{3})+(?!\d))/g, ' '); }
    function f1(v) { return v == null ? '—' : (Math.round(v * 10) / 10).toFixed(1).replace('.', /^en(?:-|$)/i.test(document.documentElement.lang || '') ? '.' : ','); }
    function etykieta(b, krok) {
        return (krok != null && krok > 0) ? f1(b * krok) + '–' + f1((b + 1) * krok) : T13.przed.replace('%1', b);
    }
    // Te same kroki co w Twigu wyzej: kubelki numerycznie, najczestszy, medianowy, udzialy.
    function policz(okno) {
        var hist = okno.rozproszenie || {}, N = okno.losowan || 0;
        var kubelki = Object.keys(hist).map(Number).sort(function (a, b) { return a - b; });
        var naj = null, najIle = 0, med = null, cum = 0, ponizej = 0, powyzej = 0;
        kubelki.forEach(function (b) {
            var ile = hist[b] || 0;
            if (ile > najIle) { naj = b; najIle = ile; }
            cum += ile;
            if (med === null && N > 0 && cum * 2 >= N) { med = b; }
        });
        kubelki.forEach(function (b) {
            if (med === null) { return; }
            if (b < med) { ponizej += hist[b] || 0; } else if (b > med) { powyzej += hist[b] || 0; }
        });
        return { N: N, hist: hist, kubelki: kubelki, naj: naj, najIle: najIle, med: med, ponizej: ponizej, powyzej: powyzej };
    }

    window.PEWNIAKI_ANALIZA = {
        plik:   '/assets/json/db/' + __pewniaki_inline_cfg[9] + '/analizy/struktura.json',
        wersja: __pewniaki_inline_cfg[10],
        wnioski: function (o, klucz, dane) {
            if (!o) { return [__pewniaki_inline_cfg[11]]; }
            var krok = krokZ(dane), r = policz(o), p = [];
            if (!r.N || !r.kubelki.length) { return [__pewniaki_inline_cfg[12]]; }
            if (r.naj !== null) {
                p.push(T13.naj.replace('%1', tys(r.N)).replace('%2', etykieta(r.naj, krok)).replace('%3', tys(r.najIle)).replace('%4', f1(r.najIle * 100 / r.N)));
            }
            if (r.med !== null) {
                p.push(T13.med.replace('%1', etykieta(r.med, krok)).replace('%2', f1(r.ponizej * 100 / r.N)).replace('%3', f1(r.powyzej * 100 / r.N)));
            }
            return p.length ? p : [__pewniaki_inline_cfg[13]];
        },
        render: function (okno, klucz, dane) {
            var q = function (s) { return document.querySelector(s); };
            var sekcja = q('[data-rozproszenie]');
            if (!okno) { if (sekcja) { sekcja.hidden = true; } return; }
            if (sekcja) { sekcja.hidden = false; }
            var krok = krokZ(dane), r = policz(okno), N = r.N;
            q('[data-rozproszenie-n]').textContent = tys(N);
            q('[data-rozproszenie-naj]').textContent = r.naj !== null ? etykieta(r.naj, krok) : '—';
            q('[data-rozproszenie-naj-opis]').textContent = (r.naj !== null && N)
                ? T13.najOp.replace('%1', tys(r.najIle)).replace('%2', f1(r.najIle * 100 / N)) : T13.brakO;
            q('[data-rozproszenie-med]').textContent = r.med !== null ? etykieta(r.med, krok) : '—';
            q('[data-rozproszenie-med-opis]').textContent = (r.med !== null && N)
                ? T13.medOp.replace('%1', f1(r.ponizej * 100 / N)).replace('%2', f1(r.powyzej * 100 / N)) : T13.brakO;
            var pierwszy = r.kubelki[0], ostatni = r.kubelki[r.kubelki.length - 1];
            q('[data-rozproszenie-zakres]').textContent = !r.kubelki.length ? '—'
                : ((krok != null && krok > 0) ? f1(pierwszy * krok) + '–' + f1((ostatni + 1) * krok) : T13.przedy.replace('%1', pierwszy).replace('%2', ostatni));
            q('[data-rozproszenie-tabela] tbody').innerHTML = (!r.kubelki.length || !N)
                ? __pewniaki_inline_cfg[14]
                : r.kubelki.map(function (b) {
                    var ile = r.hist[b] || 0;
                    return '<tr><td>' + etykieta(b, krok) + '</td><td class="liczbowa">' + tys(ile)
                        + '</td><td class="liczbowa">' + f1(ile * 100 / N) + '%</td></tr>';
                }).join('');
        }
    };
})();
})();
